<div class="mmr-initials">
   {{initials}}
</div>